export default __webpack_public_path__ + "locales/si/WebPlugins.json?hash=2b86e29be5106712597b38b55d152038";